import styled from 'styled-components';

export const CalendarContainer = styled.div``;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const MonthYearTitle = styled.div``;

export const SelectMonth = styled.select`
  width: 165px;
  height: 57px;
  border: 1px solid #d9d9d9;
  padding: 16px 24px;
  border-radius: 8px;
  font-family: 'Mangueira';
  font-weight: 600;
  font-size: 16px;
  appearance: none;
  background-color: white;
  background-image: url('data:image/svg+xml;utf8,<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.7105 15.5427L18.3605 9.88267C18.4542 9.7897 18.5286 9.6791 18.5793 9.55724C18.6301 9.43538 18.6562 9.30468 18.6562 9.17267C18.6562 9.04066 18.6301 8.90995 18.5793 8.78809C18.5286 8.66623 18.4542 8.55563 18.3605 8.46267C18.1731 8.27642 17.9196 8.17187 17.6555 8.17187C17.3913 8.17187 17.1378 8.27642 16.9505 8.46267L11.9505 13.4127L7.00045 8.46267C6.81309 8.27642 6.55964 8.17187 6.29545 8.17187C6.03127 8.17187 5.77781 8.27642 5.59045 8.46267C5.49596 8.55528 5.42079 8.66573 5.3693 8.7876C5.3178 8.90948 5.291 9.04036 5.29045 9.17267C5.291 9.30497 5.3178 9.43586 5.3693 9.55773C5.42079 9.67961 5.49596 9.79005 5.59045 9.88267L11.2405 15.5427C11.3341 15.6442 11.4477 15.7252 11.5742 15.7806C11.7007 15.836 11.8373 15.8646 11.9755 15.8646C12.1136 15.8646 12.2502 15.836 12.3767 15.7806C12.5032 15.7252 12.6168 15.6442 12.7105 15.5427Z" fill="%233D3D3D"/></svg>');
  background-repeat: no-repeat;
  background-position: right 29px center;
  cursor: pointer;
  text-transform: capitalize;

  &:focus {
    outline: none;
  }
`;

export const DayContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 24px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    align-items: center;
  }
`;

export const MonthControls = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const ButtonChangeMonth = styled.button`
  width: 57px;
  height: 57px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  background: transparent;
  color: #3d3d3d;
`;

export const AnalystyButton = styled.span`
  display: inline-block;
  font-family: 'Mangueira';
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #0b29fb;
  text-decoration: underline solid #0b29fb;
  cursor: pointer;
`;
